<template>
  <custom-dialog class="protocol-type-item-dialog" width="448px" :title="model.title" :visible="visible" v-on="$listeners">
    <div class="dialog-body">
      <el-form ref="form" :rules="rules" :model="form">
        <el-row>
          <el-col :span="24">
            <el-form-item :label="$t('dms_component_type_item_dialog.bu_jian_ming_cheng')" prop="componentName">
              <el-input v-model="form.componentName"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item :label="$t('dms_component_type_item_dialog.bu_jian_bian_hao')" prop="componentCode">
              <el-input v-model="form.componentCode"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item :label="$t('dms_component_type_item_dialog.xian_shi_shun_xu')">
              <el-input v-model="form.showOrder" type="number" :min="0"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item :label="$t('dms_component_type_item_dialog.gong_neng_fen_zu')">
              <custom-select v-model="form.componentGroup" code="iot_product_structure_service_group" valueType="number" width="100%"></custom-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item :label="$t('dms_component_type_item_dialog.duo_yu_yan_dai_ma')" prop="langComponentName">
              <el-input v-model="form.langComponentName"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item :label="$t('dms_component_type_item_dialog.bu_jian_tu_biao')">
              <template v-if="form.componentIcon">
                <div class="component-icon-container">
                  <img :src="getIconUrl(form.componentIcon)" alt="" class="img" />
                  <div class="close-content">
                    <div class="mask"></div>
                    <i class="icon icon-shanchu" @click="clearImg"></i>
                  </div>
                </div>
                <el-button class="change-icon" type="primary" @click="showComponentIconDialog">{{ $t('dms_component_type_item_dialog.geng_huan_tu_biao') }}</el-button>
              </template>
              <template v-else>
                <div class="upload-content" @click="showComponentIconDialog">
                  <i class="el-icon-plus center"></i>
                </div>
              </template>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">
        {{ $t('Common.com_cancel') }}
      </el-button>
      <el-button type="primary" @click="onConfirm">
        {{ $t('Common.com_confirm') }}
      </el-button>
    </div>
    <component-icon-dialog v-if="componentIconDialogVisible" @close="componentIconDialogVisible = false" :model="componentIconDialogModel" @confirm="componentIconConfirm"></component-icon-dialog>
  </custom-dialog>
</template>

<script>
/** 分组编辑/新增 组件 */

import apis from '@/utils/apis';

import dialogMixins from '@/mixins/dialog_mixins';
import componentIconDialog from './component_icon_dialog';

export default {
  mixins: [dialogMixins],
  components: {
    componentIconDialog,
  },
  props: {
    tabsData: {
      type: Array,
      default() {
        return [];
      },
    },
    activeIndex: Number,
    protocolCode: String,
  },
  data() {
    return {
      form: {
        componentIcon: '',
        componentName: '',
        componentCode: '',
        langComponentName: '',
        showOrder: 0,
        componentGroup: 0,
        protocolCode: '',
      },
      componentIconDialogVisible: false,
      componentIconDialogModel: {},
      iconList: [],
      bizType: 'iot.component.icon',
    };
  },
  mounted() {
    this.init();
  },

  computed: {
    rules() {
      return {
        componentIcon: {
          required: true,
          message: this.$t('Common.com_required'),
        },
        componentName: {
          required: true,
          message: this.$t('Common.com_required'),
        },
        componentCode: {
          required: true,
          message: this.$t('Common.com_required'),
        },
        langComponentName: {
          required: true,
          message: this.$t('Common.com_required'),
        },
      };
    },
  },
  methods: {
    clearImg() {
      this.iconAttach = '';
      this.form.componentIcon = '';
    },
    addIcon(item) {
      if (!this.iconList.some((obj) => obj.attachId === item.attachId)) {
        this.iconList.push(item);
      }
    },
    initIconAttach() {
      const componentIcon = this.form.componentIcon;
      if (componentIcon) {
        const item = this.iconList.find((obj) => obj.attachId === componentIcon);
        if (item) {
          this.iconAttach = item;
        }
      }
    },
    getIconList() {
      this.$getJSON(apis.ComponentIconList, {}).then((res) => {
        const iconIds = res.data;
        this.$getAttachFileList(iconIds).then((list) => {
          list.forEach((item) => {
            item.bizType = this.bizType;
          });
          this.iconList = list;
          this.initIconAttach();
        });
      });
    },
    componentIconConfirm(data) {
      this.form.componentIcon = data.attachId;
      this.addIcon(data);
      this.initIconAttach();
    },
    getIconUrl(attachId) {
      const item = this.iconList.find((obj) => obj.attachId === attachId);
      if (item) {
        return this.getAttachUrl(item);
      }
      return '';
    },
    showComponentIconDialog() {
      this.componentIconDialogModel = {
        title: this.$t('dms_component_type_item_dialog.bu_jian_tu_biao'),
      };
      this.componentIconDialogVisible = true;
    },
    validate(cb) {
      const tabs = this.tabsData.map((item) => item.label);
      const codeList = this.tabsData.map((item) => item.componentCode);
      if (this.model.type === 'edit') {
        tabs.splice(this.activeIndex, 1);
        codeList.splice(this.activeIndex, 1);
      }
      if (tabs.includes(this.form.componentName)) {
        const tips = this.$t('dms_component_type_item_dialog.fzmznwy');
        this.$message.error(tips);
        return cb(false);
      }
      if (codeList.includes(this.form.componentCode)) {
        const tips = this.$t('dms_component_type_item_dialog.fzbmznwy');
        this.$message.error(tips);
        return cb(false);
      }
      // if (!this.form.componentIcon) {
      //   const tips = '图标不能为空';
      //   this.$message.error(tips);
      //   return cb(false);
      // }
      return cb(true);
    },
    closeDialog() {
      this.visible = false;
    },
    onConfirm() {
      this.$refs.form.validate((val) => {
        if (val) {
          this.validate((validate) => {
            if (validate) {
              if (this.model.type === 'add') {
                this.create();
              } else {
                this.edit();
              }
            }
          });
        }
      });
    },
    create() {
      return this.$postJSON(apis.ComponentSaveType, this.getCreateReqData()).then((data) => {
        this.closeDialog();
        this.$message({
          message: this.$t('Common.com_handle_success'),
          type: 'success',
        });
        this.$emit('success', {
          data,
          type: 'add',
        });
      });
    },
    edit() {
      return this.$postJSON(apis.ComponentSaveType, this.getEditReqData()).then((data) => {
        this.closeDialog();
        this.$message({
          message: this.$t('Common.com_handle_success'),
          type: 'success',
        });
        this.$emit('success', {
          data,
          type: 'edit',
        });
      });
    },
    getCreateReqData() {
      const ret = {
        ...this.form,
      };
      return ret;
    },
    getEditReqData() {
      return {
        ...this.form,
        componentId: this.model.data.componentId,
      };
    },
    init() {
      this.form.protocolCode = this.protocolCode;
      this.getIconList();
      if (this.model.type === 'edit') {
        this.form.componentIcon = this.model.data.componentIcon;
        this.form.componentName = this.model.data.componentName;
        this.form.componentCode = this.model.data.componentCode;
        this.form.langComponentName = this.model.data.langComponentName;
        this.form.showOrder = this.model.data.showOrder || 0;
        this.form.componentGroup = this.model.data.componentGroup || 0;
      }
    },
  },
};
</script>

<style lang="scss">
.protocol-type-item-dialog {
  .el-form-item__label {
    text-align: left;
    width: 100% !important;
  }

  .component-icon-container {
    width: 100px;
    height: 100px;
    position: relative;
    overflow: hidden;
    border: 1px solid rgba(0, 0, 0, 0.3);
    cursor: pointer;

    &:hover {
      .close-content {
        display: block;
      }
    }

    .img {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      margin: auto;
      max-width: 95%;
      max-height: 95%;
      z-index: 0;
    }

    .close-content {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      z-index: 10;
      display: none;
      .mask {
        position: absolute;
        z-index: 0;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: #000;
        opacity: 0.3;
      }
      .icon {
        font-size: 16px;
        position: absolute;
        z-index: 10;
        left: 50%;
        top: 50%;
        transform: translate3d(-50%, -50%, 0);
        color: #fff;
      }
    }
  }

  $itemR: 100px;
  .upload-content {
    width: $itemR;
    height: $itemR;
    border: 1px dashed #c0ccda;
    position: relative;
    color: #8c939d;
    font-size: 28px;
    cursor: pointer;
    overflow: hidden;
  }

  .change-icon {
    margin-top: 15px;
  }
}
</style>
